<template>
  <b-link to="https://darksky.net/poweredby/">
    Powered By Dark Sky
  </b-link>
</template>

<script>
export default {};
</script>
